import type { ZodError } from "zod";

export const mapZodErrors = (error: ZodError): Record<string, string> =>
  Object.fromEntries(
    error.issues
      .filter((issue) => typeof issue.path[0] === "string")
      .map((issue) => [String(issue.path[0]), issue.message]),
  );
